export default function checkNumbers(word: any) {
  var numbersorder = word
    .replace(/[()]/g, "")
    .split(/[*]|[+]|[-]|[/]/)
    .sort()
    .join(",");
  return numbersorder;
}
